import type { PartnerRevisionState } from '@stores/partner-revision/partner-revision.reducers';

import { LocaleEnum } from '@loyalty/utils/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { partnerRevisionFeatureKey } from '@stores/partner-revision/partner-revision.reducers';

const selectPartnerRevisionState = createFeatureSelector<PartnerRevisionState | undefined>(partnerRevisionFeatureKey);

const selectData = createSelector(selectPartnerRevisionState, (state) => (state?.loaded ? state.data : null));

export const isLoaded = createSelector(selectPartnerRevisionState, (state) => state?.loaded ?? false);

export const revision = createSelector(selectData, (data) => data);

export const partnerId = createSelector(selectData, (data) => data?.partner.id ?? null);

export const partnerName = createSelector(selectData, (data) => data?.partner.name ?? null);

export const partnerLocale = createSelector(
  selectData,
  (data) => data?.partner.configuration.locale ?? LocaleEnum.en_GB
);

export const themes = createSelector(selectData, (data) => data?.themes ?? null);

export const status = createSelector(selectData, (data) => (data ? data.status : null));
export const protectedAccess = createSelector(selectData, (data) => data?.partner.protectedAccess ?? false);

export const hasUpsellPage = createSelector(selectData, (data) => Boolean(data?.upsellPage));

export const platformName = createSelector(selectData, (data) => data?.partner.productName ?? null);
